import * as Sentry from '@sentry/react'
import find from 'lodash/find'
import { v4 as uuid } from 'uuid'

import { hasText } from '../../helpers'

interface FormOrderPage {
  id: string
  order: number
}

interface FormOrder {
  pages: FormOrderPage[]
}

interface Page {
  order: number
  title: string
}

interface FormBuilderPageParams {
  formId?: string
  id?: string
  order?: number
  title?: string
  text?: string
  repeat_section?: boolean
  parent_page_id?: string
  allow_empty?: boolean
}

export function getNextPageOrder(
  pages: Record<string, FormOrderPage>,
  formOrder: FormOrder[],
  targetPageId?: string,
  whereToAdd: 'before' | 'after' = 'after'
) {
  const targetPage = hasText(targetPageId)
    ? find(formOrder[0].pages, ['id', targetPageId])
    : formOrder[0].pages[formOrder[0].pages.length - 1]

  if (!targetPage) {
    return 0 // or some other default value
  }

  const valueToAdd = whereToAdd === 'before' ? 0 : 1
  return pages[targetPage.id].order + valueToAdd
}

export function increasePageOrder(page: Page) {
  page.order = page.order + 1
  page.title = `Page ${page.order}`
  return page
}

export class FormBuilderPage {
  form: string
  id: string
  order: number
  title?: string
  text?: string
  isNew: boolean
  repeat_section?: boolean
  parent_page_id?: string
  allow_empty?: boolean

  constructor(
    {
      formId,
      id,
      order = 0,
      title,
      text,
      repeat_section = false,
      parent_page_id,
      allow_empty = false,
    }: FormBuilderPageParams,
    isNew = true
  ) {
    if (!order) {
      Sentry.captureEvent({
        message: 'Order is required',
        level: 'error',
        tags: {
          context: 'FormBuilder',
        },
        extra: {
          formId,
          id,
          order,
          title,
          text,
        },
      })
    }
    this.form = formId ?? uuid()
    this.id = id ?? uuid()
    this.order = Number(order)
    this.title = title
    this.text = text
    this.isNew = isNew
    this.repeat_section = repeat_section
    this.parent_page_id = parent_page_id
    this.allow_empty = allow_empty
  }
}
